const RELOAD_AT_KEY = "todas:preloadErrorReloadAt";

export const PRELOAD_ERROR_RELOAD_GUARD_MS = 10_000;

/**
 * Rozhodne, jestli po `vite:preloadError` znovu načíst stránku.
 *
 * AIDEV-NOTE: Chunk chybí, když záložka drží starý `index.html` a deploy mezitím smazal
 * hashované soubory — reload načte novou verzi. Pojistka v sessionStorage brání cyklu, kdyby
 * chunk chyběl i v nové verzi; když ji nejde zapsat, reload se raději nedělá. [TD-452]
 *
 * AIDEV-NOTE: `speculative` = selhalo přednačtení, o které student nežádal (`calendarRoute`: idle, najetí
 * na odkaz). Reload by ho vyhodil z rozdělané práce kvůli stránce, kterou nepotřebuje, takže se přeskočí
 * i se zápisem pojistky. Řešení přes příznak, ne `event.preventDefault()`: `preventDefault` je globální
 * pro událost (Vite ji vysílá synchronně z `__vitePreload` a po `preventDefault` vrací `undefined` místo
 * zamítnutí), kdežto bez něj se chyba dál šíří jako zamítnutý promise a `lazyWithPreload` se z ní umí
 * zotavit při skutečné navigaci. `.catch` na promise nestačí, událost padne dřív. [TD-476]
 */
export const shouldReloadAfterPreloadError = (now: number, { speculative = false } = {}): boolean => {
  if (speculative) return false;

  try {
    const lastReloadAt = Number(window.sessionStorage.getItem(RELOAD_AT_KEY));

    if (now - lastReloadAt <= PRELOAD_ERROR_RELOAD_GUARD_MS) return false;

    window.sessionStorage.setItem(RELOAD_AT_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};
